define('views/components/cd_product/cd_product',['require','backbone','text!templates/components/cd_product/cd_product.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/cd_product/cd_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-product-item'
    });
});
